'use client';
import { _ as _extends } from './cc-he3fHS3P.js';
import { jsx } from 'react/jsx-runtime';
import { getLocaleObjectFromIETFLanguageTag } from '@repo/lib';
import { ShopifyProvider as ShopifyProvider$1, CartProvider as CartProvider$1 } from '@shopify/hydrogen-react';
import { z } from 'zod';

const variables = {
    ANALYZE: process.env.ANALYZE,
    NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
    NEXT_PUBLIC_GENERAL_EMAIL: process.env.NEXT_PUBLIC_GENERAL_EMAIL,
    NEXT_PUBLIC_LEGAL_NAME: process.env.NEXT_PUBLIC_LEGAL_NAME,
    NEXT_PUBLIC_PROTOCOL: process.env.NEXT_PUBLIC_PROTOCOL,
    NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NEXT_PUBLIC_TAX_ID: process.env.NEXT_PUBLIC_TAX_ID,
    NODE_ENV: process.env.NODE_ENV
};
const publicVariablesSchema = z.object({
    NEXT_PUBLIC_DEFAULT_LOCALE: z.string(),
    NEXT_PUBLIC_GENERAL_EMAIL: z.email(),
    NEXT_PUBLIC_LEGAL_NAME: z.string(),
    NEXT_PUBLIC_PROTOCOL: z.union([
        z.literal("http"),
        z.literal("https")
    ]),
    NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: z.string(),
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: z.string(),
    NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: z.string(),
    NEXT_PUBLIC_TAX_ID: z.string(),
    NEXT_PUBLIC_SITE_NAME: z.string(),
    NODE_ENV: z.enum([
        "development",
        "production",
        "test"
    ])
});
const privateVariablesSchemaClient = z.object({
    ANALYZE: z.undefined()
});
const privateVariablesSchemaServer = z.object({
    ANALYZE: z.stringbool().optional()
});
const envSchema = z.intersection(publicVariablesSchema, typeof window === "undefined" ? privateVariablesSchemaServer : privateVariablesSchemaClient);
const env = envSchema.parse(variables);

const storefrontToken = env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN;
const storeDomain = env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN;
const storefrontApiVersion = env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION;
function ShopifyProvider({ children, lang }) {
    var _localeTag_region;
    const localeTag = getLocaleObjectFromIETFLanguageTag(lang);
    const countryIsoCode = (_localeTag_region = localeTag.region) != null ? _localeTag_region : "US";
    const languageIsoCode = localeTag.language;
    const shopifyConfig = {
        countryIsoCode,
        languageIsoCode,
        storeDomain,
        storefrontApiVersion,
        storefrontToken
    };
    return /*#__PURE__*/ jsx(ShopifyProvider$1, _extends({}, shopifyConfig, {
        children: children
    }));
}
function CartProvider({ children, lang }) {
    var _localeTag_region;
    const localeTag = getLocaleObjectFromIETFLanguageTag(lang);
    const countryIsoCode = (_localeTag_region = localeTag.region) != null ? _localeTag_region : "US";
    const languageIsoCode = localeTag.language;
    const shopifyConfig = {
        countryIsoCode,
        languageIsoCode,
        storeDomain,
        storefrontApiVersion,
        storefrontToken
    };
    return /*#__PURE__*/ jsx(ShopifyProvider$1, _extends({}, shopifyConfig, {
        children: /*#__PURE__*/ jsx(CartProvider$1, {
            countryCode: countryIsoCode,
            children: children
        })
    }));
}

export { CartProvider, ShopifyProvider };
